import { combineReducers } from 'redux';
import drawerReducer from './drawerReducer';
import auth from './auth';
import teamReducer from './teamReducer';
import devicesReducer from './devicesReducer';
import childReducer from './childReducer';
import policyReducer from './policyReducer';
import defaultDownTimeReducer from './defaultDownTimeReducer';
import navigationHistoryReducer from './navigationHistoryReducer';
import notificationReducer from './notification';
import policyRequests from './policyRequestReduer';
import programFormReducer from './programFormReducer';
import programReducer from './programReducer';
import dashboardReducer from './dashboardReducer';
import myResultReducer from "./myResultReducer";
import appChatReducer from "./appChatReducer";
import programEnrollmentReducer from './programEnrollmentReducer';
import channelThemeReducer from './channelThemeReducer';
import communityRolesReducer from './communityRolesReducer';
import notificationSettingsReducer from './notificationSettingsReducer';
import testManagementReducer from './testManagementReducer';
import contentLogsReducer from './contentLogsReducer';
import analyticsReducer from './analyticsReducer';

export default combineReducers({
  drawerReducer,
  auth,
  teamReducer,
  devicesReducer,
  childReducer,
  policyReducer,
  defaultDownTimeReducer,
  navigationHistoryReducer,
  notificationReducer,
  notificationSettingsReducer,
  policyRequests,
  appChatReducer,
  programReducer,
  programFormReducer,
  programEnrollmentReducer,
  dashboardReducer,
  myResultReducer,
  channelThemeReducer,
  communityRolesReducer,
  testManagementReducer,
  contentLogsReducer,
  analyticsReducer
});
